import ReactDOMServer from 'react-dom/server';
import {Moment} from 'moment';
import {useMemo} from 'react';
import {CakeOutlined} from '@mui/icons-material';
import {Calendar} from '../../../../../../../components/calendar/calendar';
import {DateRangeType} from '../../../../../../../components/date-range-input/date-range-utils';
import {transformPlannerItems2CalendarData} from './planner-data-transformation';
import {OnPlannerItemClicked, PlannerItem} from './planner-item';
import './planner-calendar.scss';

type PlannerCalendarProps = {
  items: PlannerItem[];
  itemsLoading: boolean;
  range: DateRangeType;
  date: Moment;
  onItemClicked: OnPlannerItemClicked;
};

export function PlannerCalendar(props: PlannerCalendarProps) {
  const calendarData = useMemo(
    () => transformPlannerItems2CalendarData(props.items),
    [props.items]
  );

  return (
    <Calendar
      className="planner-calendar"
      data={calendarData}
      dataLoading={props.itemsLoading}
      range={props.range}
      date={props.date}
      onClickItem={(evt, calendarEvt) => {
        const item = props.items.find((it) => it.id === calendarEvt.id);
        if (item) {
          props.onItemClicked(evt, item);
        } else {
          console.error('Planner Item not found');
        }
      }}
      eventDidMount={(info) => {
        // Add icon to event title when applicable
        if (info.event.extendedProps.icon) {
          const el = info.el.querySelector<HTMLElement>('.fc-event-title');
          const iconStr = info.event.extendedProps.icon;
          if (el) {
            el.style.display = 'flex';
            el.style.placeItems = 'center';
            const icon = document.createElement('span');
            if (iconStr === 'brithday') {
              icon.innerHTML = ReactDOMServer.renderToString(
                <CakeOutlined style={{marginRight: '2px', width: '13px', height: '12px'}} />
              );
            }
            el.prepend(icon);
          }
        }
      }}
    />
  );
}
